class SvgLines {
  constructor(svg) {
    this.svg = svg
    this.lineClassList = 'line right'
    this.lines = []
    this.pointLine = null
    if (!svg) return
    this.init()
  }

  init() {
    const self = this
    window.addEventListener('resize', () => { self.setInnerHTML() })
  }

  addRight(from, to) {
    this.removePoint()
    if (this.isNotValid(from, to)) return

    const classList = 'line right'
    this.lines.push({ classList, from, to })
    this.setInnerHTML()
  }

  addWrong(from, to) {
    this.removePoint()
    if (this.isNotValid(from, to)) return

    const classList = 'line wrong'
    this.lines.push({ classList, from, to })
    this.setInnerHTML()
  }

  setPoint(from, x, y) {
    this.pointLine = { from, x, y }

    this.setInnerHTML()
  }

  removePoint() {
    if (!this.pointLine) return
    this.pointLine = null

    this.setInnerHTML()
  }

  remove(from, to) {
    const index = this.indexOfElements(from, to)

    if (index > -1) this.lines.splice(index, 1)

    this.setInnerHTML()
  }

  removeLast() {
    this.lines.splice(this.lines.length - 1, 1)

    this.setInnerHTML()
  }

  isNotValid(from, to) {
    return !this.isValid(from, to)
  }

  isValid(from, to) {
    if (!from && !to) return false

    return this.indexOfElements(from, to) === -1
  }

  indexOfElements(from, to) {
    return this.lines.findIndex(el => (el.from === from && el.to === to) || (el.from === to && el.to === from))
  }

  setInnerHTML() {
    const { lines, pointLine } = this
    let data = ''

    lines.forEach((el) => {
      const { x: x1, y: y1 } = this.getCoords(el.from)
      const idFrom = el.from.getAttribute('data-id')

      const { x: x2, y: y2 } = this.getCoords(el.to)
      const idTo = el.to.getAttribute('data-id')

      data += `<line id="${idFrom}-${idTo}" class="${el.classList}" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"></line>`
    })

    if (pointLine) {
      const { x: x1, y: y1 } = this.getCoords(pointLine.from)
      data += `<line id="svg-lines-point" class="line" x1="${x1}" y1="${y1}" x2="${pointLine.x}" y2="${pointLine.y}"></line>`
    }

    this.svg.innerHTML = data
  }

  // eslint-disable-next-line class-methods-use-this
  getCoords(el) {
    const {
      left, top, width, height,
    } = el.getBoundingClientRect()
    const x = left + (width / 2)
    const y = top + (height / 2)
    return { x, y }
  }
}

export default SvgLines
